import { render, staticRenderFns } from "./gift-detail.vue?vue&type=template&id=0286de54&scoped=true&"
import script from "./gift-detail.vue?vue&type=script&lang=js&"
export * from "./gift-detail.vue?vue&type=script&lang=js&"
import style0 from "./gift-detail.vue?vue&type=style&index=0&id=0286de54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0286de54",
  null
  
)

export default component.exports